export default {
      id: "social-facebook-usage",
      viewBox: "0 0 10 20",
      url: __webpack_public_path__ + "sprite.svg#social-facebook",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social-facebook.svg
// module id = 136
// module chunks = 241 242 243